var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_181_206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_181_206",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_181_206",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_181_206",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEkElEQVR4nO2dS4hcRRSGmxgFQcXXSiM+ENT4dhTGYbCo/z+3nYUSNVyUgBslCa6yCC7c2CDBtSj4woWIikZRg8aYlRJEBEFHJOJKN2J8xccMCL4ycpxukEbS53bfmpq+93xQ2+665+t63KpT1Z2O4ziO4ziO4ziO4ziO4xyHoiguJPkiyW9JroxZlgG8QfIiD3YFiqK4AsCvEwR+uCyFEC52CUYAvFVj8Fe0ADjgAozoL7ZuAST/KMvyBJdgawF/JRCw0u12z3QBthbwWwoBIYRNLsDWAn5JISDGeIkLsLWAI4kEzLgAm4DDKQSIyM0uwCbgUAoBAO51ATYBryUS8KALMADg0RQCSD7jAmwCdicSsOgCbF3Q1kRd0N8LCwunuQTDYlyiFrBCUlzACGZmZk4E8HsiAXtcgK0b+jRRN/SJC7AJeC5RCzgG4FyXMAIRuS/VOCAi21zACGKMV6cSAGC3CxiBbp6kWhUleYsLyLQkAeBznWW5AAMAdtYc/O9E5DIPvpEY4/k1Bv97EbnSg18RAB/XIOAnANd58MeA5AOTBj/6Ttj4aFbbBMH/2YNfAyQ/HCf4InJ9Hd/fekRke9Xgk7yh9YGrixDCKRWy5Tz4KSD5pA+4Gel2u5fqSuYICfty1rHxkNxveOEqctezsYhIMHRDi54FnRAA7xpawc6UdWg1McabLOs+JM/KXdfGoqddDBJeyl3PxqJLyiT/NIwHd+aua2MB8LjlpSz4oYw0aB/f7+tHdUUHer3ehkTVaDcxxrstyxMAHspd18ZC8qBBwjERuSN3XRuJJlkBOGqQsKw5p7nr20g00crYFX3pWXGJ6N8rYVmuPhxCODtVPdq+Z2A93LcYQjg9d52b+oK2bJRwyA9rJADA7XoSxjgmfJSyOyrL8iSSW0jer+NUa8YffeAqqYpIEBgAm0l+MTwd1vMJAB7Wkzpzc3OndpoKgKesEkh+VecUVTPwjG/peinJIoCn9QgtyXtILmgqje4AhhAumJ+fPyOEsLEzbeimDMm9FSTo2LF10u8FcJUl+FVKX9TBqbt0qt8Hv13hYXXPec+4a0f9Mw0/1Bn8obI0ddevzc7OnlxRgv7i3hGRc6p8T1EU1wD4MWHwB+X1zrRRrraEvRUlHAVwl+XzSV67RsH/txV0ppFydUyw5BYNi3j5eNubmnVtXIuqrXSmGQC7rO8JQ61h13C2xRr/8pshQAFw25gXA+qUMepn6FRRU9/XOviNEPCfTLtxL4balyv4jREwWMAD8HyuQLZewAAA5VoPpC5giG63e57O/3MHt1Vd0P8B4FaSX+cOcmsFKHrDLsnHjMlfLiDxBs/+3AFvXQsYhuSNAN7MHfjWChggIvMqouqbtAuoGb2DmuQTFfafvQWkQLcU9TZeAB+4gHVwsQhWF/reNxwmnKQcyf2s654QwiZtGSRfqXvNCMALuZ9vquj1ehtijJeT3AHgWb39ZdwrOfUGMf13qdzPNPWEEDb201a2aLdF8hEArwJ4D8BnAL7pt5zBkvlSf/a1OXfdHcdxHMdxHMdxHMdxnM665h8Jc4xJHH5qUAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.27ef77346efc5163e55d19f2ad98a5e1.svg";
export { ForwardRef as ReactComponent };